import React, { useState } from 'react';
import { Button, Image, Modal } from 'semantic-ui-react';
import logo from '../assets/clear_text_fields_x.svg';

const ConfirmButton = ({ title, handleClear }) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleConfirm = () => {
    setOpen(false);
    handleClear(); // Call the clear function passed as a prop
  };

  return (
    <div >
      <Button basic type="button" style={{ display: 'flex', alignItems: 'center', padding: "5px 0px 5px 0px" }} onClick={handleOpen}>
        <Image src={logo} style={{ height: "20px", marginRight: '4px', marginLeft: "8px" }} />
        <span style={{ fontSize: "1.0rem", paddingRight: "8px" }}>Clear all</span>
      </Button>

      <Modal
        size='tiny'
        open={open}
        onClose={handleClose}
      >
        <Modal.Header>{title}</Modal.Header>
        <Modal.Content>
          <span className="confirmTitle">Confirm Action</span><br />
          <span className='confirmSubTitle'>Are you sure you want to clear all?</span>
        </Modal.Content>
        <Modal.Actions>
          <Button negative onClick={handleClose}>
            No
          </Button>
          <Button positive onClick={handleConfirm}>
            Yes
          </Button>
        </Modal.Actions>
      </Modal>
    </div>
  );
};

export default ConfirmButton;
